import { Flex, Text } from "@chakra-ui/react"
import { Badge, Heading } from "DesignSystem/components"
import { CheckCircleFilledIcon } from "Icons/CheckCircleFilledIcon"
import { CheckCircleIcon } from "Icons/CheckCircleIcon"
import { RemoveFilledIcon } from "Icons/RemoveFilledIcon"
import React from "react"
import { OnboardingStatus } from "./constants"

export type OnboardingCardProps = {
  title: string
  description: string
  required: boolean
  actions: React.ReactNode
  status: OnboardingStatus
}

export const OnboardingCard: React.FC<OnboardingCardProps> = ({
  title,
  description,
  required,
  actions,
  status,
}) => {
  return (
    <Flex
      gap={4}
      bg="ds.surface.raised.resting"
      boxShadow="ds.raised"
      py={4}
      ps={3}
      pe={4}
      rounded="12px"
    >
      <OnboardingCardIcon status={status} />

      <Flex flexDirection="column" gap={4} flexGrow={1}>
        <Flex flexDirection="column" gap={2}>
          <Flex gap={2} justify="space-between" align="baseline">
            <Heading as="h3" textStyle="ds.heading.tertiary">
              {title}
            </Heading>
            {required && <Badge label="Required" />}
          </Flex>
          {description && (
            <Text textStyle="ds.paragraph.secondary">{description}</Text>
          )}
        </Flex>
        {status === "incomplete" && actions}
      </Flex>
    </Flex>
  )
}

const OnboardingCardIcon: React.FC<{
  status: "incomplete" | "not_required" | "complete" | "rejected"
}> = ({ status }) => {
  if (status === "incomplete")
    return <CheckCircleIcon boxSize={5} color="ds.icon.disabled" />

  if (status === "complete")
    return <CheckCircleFilledIcon boxSize={5} color="ds.icon.success" />

  if (status === "rejected")
    return <RemoveFilledIcon boxSize={5} color="ds.icon.danger" />

  return <></>
}
